<template>
	<div class="">
		<div>
			<div class="msglist">
				<el-tabs type="border-card" v-model="tabindex" @tab-click="tapTab">
					<el-tab-pane label="系统消息"><div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无消息 ——</div></el-tab-pane>
					<el-tab-pane label="物流消息"><div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无消息 ——</div></el-tab-pane>
					<el-tab-pane label="优惠券消息"><div class="wd-p-20 wd-theme-666 wd-text-center">—— 暂无消息 ——</div></el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Msglist',
	data() {
		return {
			oldtabindex: 0,
			tabindex: 0
		};
	},
	methods: {
		tapTab() {
			if (this.oldtabindex !== this.tabindex) {
				this.oldtabindex = this.tabindex;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.msglist {
	width: 100%;
	.left {
		width: 100px;
		background-color: #e0f0fd;
		.title {
			height: 40px;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			&:hover {
				background-color: #f2f6fc;
			}
		}
	}
	.right {
		margin-left: 20px;
	}
}
</style>
